import "./task.css";
import { useState } from "react";
import TaskItem from "../TaskItem/TaskItem";
import EditTask from "../EditTask/EditTask";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../firebase";

function Task({ id, marka, product, minPay, minFollowers, completed }) {
  const [checked, setChecked] = useState(completed);
  const [open, setOpen] = useState({ edit: false, view: false });

  const handleClose = () => {
    setOpen({ edit: false, view: false });
  };

  /* function to update firestore */
  const handleChange = async () => {
    const taskDocRef = doc(db, "ilanlar", id);
    try {
      await updateDoc(taskDocRef, {
        completed: checked,
      });
    } catch (err) {
      alert(err);
    }
  };

  /* function to delete a document from firstore */
  const handleDelete = async () => {
    const taskDocRef = doc(db, "ilanlar", id);
    try {
      await deleteDoc(taskDocRef);
    } catch (err) {
      alert(err);
    }
  };

  return (
    <>
      <tr>
        <td>{marka}</td>
        <td>{product}</td>
        <td>{minPay}</td>
        <td>{minFollowers}</td>
        <td>
          <button
            className="view"
            onClick={() => setOpen({ ...open, view: true })}
          >
            View
          </button>
        </td>
        <td>
          <div>
            <input
              id={`checkbox-${id}`}
              className="checkbox-custom"
              name="checkbox"
              checked={checked}
              onChange={handleChange}
              type="checkbox"
            />
            <label
              htmlFor={`checkbox-${id}`}
              className="checkbox-custom-label"
              onClick={() => setChecked(!checked)}
            >
              Onayla
            </label>
          </div>
        </td>
        <td>
          <button
            className="task__editButton"
            onClick={() => setOpen({ ...open, edit: true })}
          >
            Edit
          </button>
        </td>
        <td>
          <button className="task__deleteButton" onClick={handleDelete}>
            Delete
          </button>
        </td>
      </tr>

      {open.view && (
        <TaskItem
          onClose={handleClose}
          marka={marka}
          product={product}
          minFollowers={minFollowers}
          minPay={minPay}
          open={open.view}
        />
      )}

      {open.edit && (
        <EditTask
          onClose={handleClose}
          toEditMarka={marka}
          toEditProduct={product}
          toEditMinFollowers={minFollowers}
          toEditPay={minPay}
          open={open.edit}
          id={id}
        />
      )}
    </>
  );
}

export default Task;
